module Arkadium.Game.Localization
{
    "use strict"

    export class LocalizationConstants
    {
        public static en_US:string = "en-US";
        // public static de_DE:string = "de-DE";
        // public static es_ES:string = "es-ES";
        // public static fr_FR:string = "fr-FR";
        // public static it_IT:string = "it-IT";

        public static ONES:string = "ones";
        public static TWOS:string = "twos";
        public static THREES:string = "threes";
        public static FOURS:string = "fours";
        public static FIVES:string = "fives";
        public static SIXES:string = "sixes";
        public static THE_SAME_3_KIND:string = "thesame3kind";
        public static THE_SAME_4_KIND:string = "thesame4kind";
        public static THE_SAME_5_KIND:string = "thesame5kind";
        public static FULL_HOUSE:string = "fullhouse";
        public static SMALL_STRAIGHT:string = "smallstraight";
        public static STRAIGHT:string = "straight";
        public static CHANCE:string = "chance";
        public static ROLL:string = "roll";
        public static ROLLX:string = "rollx";
        public static NO_ROLL:string = "no_roll";
        public static TOTAL:string = "total";
        public static YES:string = "yes";
        public static NO:string = "no";
        public static PLAY:string = "play";
        public static PREV:string = "prev";
        public static NEXT:string = "next";
        public static NOT_SUPPORTING_WEBGL_MESSAGE:string = "not_supporting_webgl_message";

        public static HELP_TITLE:string = "help_title";
        public static HELP_SHOW_HELP_AT_START:string = "help_show_help_at_start";
        public static HELP_PAGE_1_TEXT_1:string = "help_page_1_text_1";
        public static HELP_PAGE_1_TEXT_2:string = "help_page_1_text_2";
        public static HELP_PAGE_2_TEXT_1:string = "help_page_2_text_1";
        public static HELP_PAGE_2_TEXT_2:string = "help_page_2_text_2";
        public static HELP_PAGE_3_TEXT_1:string = "help_page_3_text_1";
        public static HELP_PAGE_3_TEXT_2:string = "help_page_3_text_2";
        public static HELP_PAGE_4_TEXT_1:string = "help_page_4_text_1";
        public static HELP_PAGE_4_TEXT_2:string = "help_page_4_text_2";
        public static HELP_PAGE_4_TEXT_3:string = "help_page_4_text_3";
        public static HELP_PAGE_4_TEXT_4:string = "help_page_4_text_4";
        public static HELP_PAGE_5_TEXT_1:string = "help_page_5_text_1";
        public static HELP_PAGE_5_TEXT_2:string = "help_page_5_text_2";
        public static HELP_PAGE_5_TEXT_3:string = "help_page_5_text_3";
        public static HELP_PAGE_5_TEXT_4:string = "help_page_5_text_4";
        public static HELP_PAGE_5_TEXT_5:string = "help_page_5_text_5";
        public static HELP_PAGE_5_TEXT_6:string = "help_page_5_text_6";
        public static HELP_PAGE_6_TEXT_1:string = "help_page_6_text_1";
        public static HELP_PAGE_6_TEXT_2:string = "help_page_6_text_2";
        public static HELP_PAGE_6_TEXT_3:string = "help_page_6_text_3";
        public static HELP_PAGE_6_TEXT_4:string = "help_page_6_text_4";
        public static HELP_PAGE_6_TEXT_5:string = "help_page_6_text_5";
        public static HELP_PAGE_6_TEXT_6:string = "help_page_6_text_6";

        public static MSG_ROLL:string = "msg_roll";
        public static MSG_SELECT:string = "msg_select";
        public static MSG_SCORE:string = "msg_score";
        public static ARE_YOU_SURE_QUIT:string = "are_you_sure_quit";
        public static YOUR_SCORE:string = "your_score";

        public static HINT_UP_ALL_THE_1S:string = "hint_up_all_the_1s";
        public static HINT_UP_ALL_THE_2S:string = "hint_up_all_the_2s";
        public static HINT_UP_ALL_THE_3S:string = "hint_up_all_the_3s";
        public static HINT_UP_ALL_THE_4S:string = "hint_up_all_the_4s";
        public static HINT_UP_ALL_THE_5S:string = "hint_up_all_the_5s";
        public static HINT_UP_ALL_THE_6S:string = "hint_up_all_the_6s";
        public static HINT_3_OF_A_KIND:string = "hint_3_of_a_kind";
        public static HINT_4_OF_A_KIND:string = "hint_4_of_a_kind";
        public static HINT_5_OF_A_KIND:string = "hint_5_of_a_kind";
        public static HINT_FULL_HOUSE:string = "hint_full_house";
        public static HINT_SM_STRAIGHT:string = "hint_sm_straight";
        public static HINT_LG_STRAIGHT:string = "hint_lg_straight";
        public static HINT_CHANCES:string = "hint_chances";
    }
}




// WEBPACK FOOTER //
// src/typescript/Game/Localization/LocalizationConstants.ts